<template>
  <div class="ranking-page">
    <q-card class="my-card">
      <q-card-section class="card-section">
        <div class="card-title">Ranking (Top 5)</div>
      </q-card-section>
      <q-separator />

      <q-card-section class="card-content">
        <ranking-slot
          v-for="(ranking,index) in getRanking"
          :key="ranking.ChaName"
          :chaInfo="ranking"
          :rankNum="index + 1"
        />
      </q-card-section>
    </q-card>
  </div>
</template>
<script>
import RankingSlot from '@/components/ranking/RankingSlot.vue';
import { mapGetters } from 'vuex';
export default {
  name: 'RankingPage',
  components: {
    RankingSlot
  },
  computed: {
    ...mapGetters({
      getRanking: 'home/getRanking'
    })
  }
}
</script>

<style lang="scss">
.ranking-page {
  margin-top: 16px;

  .my-card {
    background-color: $backgroundHeader;

    .card-title {
      font-size: 16px;
      font-weight: 700;
    }

    .card-section {
      color: white;
    }

    .card-content {
      background-color: $background;
      display: grid;
      grid-template-rows: 1fr 1fr;
      gap: 16px;
      .class-type {
        img {
          width: 50px;
          height: 50px;
        }
      }
    }
  }
}
</style>